import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region redux
//#endregion
//#region types
import { PaymentFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { StoppedPaymentsTodoSelectionFormContainerProps } from "models/propTypes/paymentPropTypes";
//#endregion
//#region components
import StoppedPaymentsSelectionForm from "./todoSelectionForm";
//#endregion
import * as Yup from "yup";
import { DateHelper } from "utils/helpers";

const StoppedPaymentsTodoSelectionFormContainer: ForwardRefRenderFunction<
  FormHandles,
  StoppedPaymentsTodoSelectionFormContainerProps
> = (props, ref) => {
  const validationSchema = Yup.object<PaymentFormTypes.StoppedPaymentTodo>({
    newPayoutDate: Yup.date()
      .required(TranslationKeys.Validations.Required)
      .typeError(TranslationKeys.Validations.InvalidDate),
  });

  const initialValues: PaymentFormTypes.StoppedPaymentTodo = {
    newPayoutDate: DateHelper.today(),
  };

  return (
    <StoppedPaymentsSelectionForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={initialValues}
    />
  );
};

export default forwardRef(StoppedPaymentsTodoSelectionFormContainer);
